import { render, staticRenderFns } from "./transporter.vue?vue&type=template&id=0ac00a73&scoped=true&"
import script from "./transporter.vue?vue&type=script&lang=js&"
export * from "./transporter.vue?vue&type=script&lang=js&"
import style0 from "./transporter.vue?vue&type=style&index=0&id=0ac00a73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac00a73",
  null
  
)

export default component.exports